import React from 'react';

interface Tab {
    key: string;
    label: string;
}

interface TimesheetTabsProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabKey: string) => void;
}

const TimesheetTabs: React.FC<TimesheetTabsProps> = ({ tabs, activeTab, onTabChange }) => {
    return (
        <div className="timesheet-tabs-container">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    className={`timesheet-tab ${activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.key)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default TimesheetTabs;
